import React, {Component} from 'react';
import {List} from 'antd';

import {Order} from '../../../../../../../../interfaces';

interface Properties {
  orderData: Order;
}

class Payment extends Component<Properties> {
  getListData(): JSX.Element[] {
    const {
      payment,
      order: {merchantTransactionId},
    } = this.props.orderData;
    const origin = payment.originalBody || null;
    const card = origin ? origin.card : null;
    return [
      <>
        <b>Payment gateway:</b>
        {payment.type || '-'}
      </>,
      <>
        <b>Payment ID:</b>
        {payment.paymentId || '-'}
      </>,
      <>
        <b>Payment processed:</b>
        {payment.processed === true ? 'Yes' : payment.processed === false ? 'No' : '-'}
      </>,
      <>
        <b>Merchant transaction ID:</b>
        {merchantTransactionId || '-'}
      </>,
      <>&nbsp;</>,
      <>
        <b>IBAN:</b>
        {payment.iban || '-'}
      </>,
      <>
        <b>BIC:</b>
        {payment.swift || '-'}
      </>,
      <>&nbsp;</>,
      card ? (
        <>
          <b>Card bin:</b>
          {card.bin || '-'}
        </>
      ) : null,
      card ? (
        <>
          <b>Card exp:</b>
          {card.expiryMonth || '-'}/{card.expiryYear || '-'}
        </>
      ) : null,
      card ? (
        <>
          <b>Card brand:</b>
          {origin.paymentBrand || '-'}
        </>
      ) : null,
      card ? (
        <>
          <b>Card holder:</b>
          {card.holder || '-'}
        </>
      ) : null,
      <>
        <b>Amount:</b>
        {origin && origin.amount ? origin.amount : payment.paymentAmount ? payment.paymentAmount : '-'}{' '}
        {origin && origin.currency ? origin.currency : payment.currency ? payment.currency : ''}
      </>,
      <>
        <b>Registration id:</b>
        {origin ? origin.registrationId || '-' : '-'}
      </>,
    ].filter(a => !!a);
  }

  render(): JSX.Element {
    if (!this.props.orderData.payment) {
      return (
        <>
          <h3 style={{marginBottom: 16, fontWeight: 600}}>Payment details</h3>
          <div>
            <span>No payment details</span>
          </div>
        </>
      );
    }

    return (
      <>
        <h3 style={{marginBottom: 16, fontWeight: 600}}>Payment details</h3>
        <List size="small" bordered dataSource={this.getListData()} renderItem={(item: JSX.Element) => <List.Item>{item}</List.Item>} />
      </>
    );
  }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/components/Payment/Payment.tsx